function Sidebar() {
  return (
    <div className="sidebar"></div>
  );
}

export default Sidebar;